import { observer } from 'mobx-react';
import React from 'react';

import {
  DbKey,
} from '../../../../adl-gen/common/db';
import { Skill } from '../../../../adl-gen/totalinteraction/futurefit/db';
import { Loader } from '../../../../loader/loader';
import { Route } from '../../../../routing/app-routes';
import { SkillListAndData, SkillStore } from '../../../stores';
import { FormMode } from '../../common/form';
import { AdminPageLayoutFn } from '../../common/page-layout/admin-page-layout';
import { SkillForm } from '../../components/forms/skill-form/skill-form';
import { SkillDetailsView } from '../../components/detail-views/skill-details-view';

interface SkillDetailScreenProps {
  pageLayout: AdminPageLayoutFn;
  navigateTo(route: Route): void;
  mode?: FormMode;

  store: SkillStore;

  onCancel?(): Promise<void>;
  onUpdate?(skillId: DbKey<Skill>): Promise<void>;
}

@observer
export class SkillDetailScreen extends React.Component<SkillDetailScreenProps> {
  renderSkillDetails = observer((data: SkillListAndData) => {
    const { onUpdate, store } = this.props;
    const { selected } = data;

    if (!store.isSuperUser) {
      throw Error('Not authorized');
    }

    if (selected && onUpdate) {
      return (
        <SkillDetailsView skill={selected} data={data} onUpdate={onUpdate} role={'super'} />
      );
    } else {
      return null;
    }
  });

  renderCreateSkillForm = observer((data: SkillListAndData) => {
    const { mode, navigateTo, onCancel, store } = this.props;

    if (!store.isSuperUser) {
      throw Error('Not authorized');
    }

    if (onCancel) {
      return (
        <SkillForm store={store} data={data} mode={mode} onCancel={onCancel} navigateTo={navigateTo} />
      );
    } else {
      return null;
    }
  });

  renderUpdateSkillForm = observer((data: SkillListAndData) => {
    const { mode, navigateTo, onCancel, store } = this.props;

    const { selected } = data;

    if (!store.isSuperUser) {
      throw Error('Not authorized');
    }

    if (selected && onCancel) {
      return (
        <SkillForm
          item={selected}
          store={store}
          data={data}
          mode={mode}
          onCancel={onCancel}
          navigateTo={navigateTo}
        />
      );
    } else {
      return null;
    }
  });

  SkillDetailsLoader = () => {
    const { store, mode } = this.props;
    const skill = store.selected;
    if (skill) {
      if (mode === 'update' || mode === 'delete') {
        return <Loader state={store.loadingAll} LoadedComponent={this.renderUpdateSkillForm} />;
      } else {
        /// View
        return <Loader state={store.loadingAll} LoadedComponent={this.renderSkillDetails} />;
      }
    } else {
      /// Create - mode doesn't matter
      return <Loader state={store.loadingAll} LoadedComponent={this.renderCreateSkillForm} />;
    }
  };

  render() {
    return (
      <this.props.pageLayout title={'Administration - Skill'}>
        <this.SkillDetailsLoader />
      </this.props.pageLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/screens/skill-detail-screen/skill-detail-screen.tsx